import type { RouteObject } from "react-router-dom";
import SiteLayout from "@/components/feature/SiteLayout";
import Home from "@/pages/home/page";
import NewsPage from "@/pages/news/page";
import PlotPage from "@/pages/plot/page";
import CastPage from "@/pages/cast/page";
import RecommendPage from "@/pages/recommend/page";
import DetailPage from "@/pages/detail/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/news", element: <NewsPage /> },
      { path: "/plot", element: <PlotPage /> },
      { path: "/cast", element: <CastPage /> },
      { path: "/recommend", element: <RecommendPage /> },
      { path: "/detail/:id", element: <DetailPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "/contact", element: <ContactPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;